import { styled } from '@mui/material/styles'

import Fonts from '#/styles/Fonts'

export const Wrapper = styled('div')({
  alignItems: 'center',
  display: 'flex',
  gap: 5,
  lineHeight: 'normal',
})

interface SegmentProps {
  bold?: boolean
  textColor?: string
}

export const Segment = styled('span', {
  shouldForwardProp: propName => !['bold', 'textColor'].includes(propName as string),
})<SegmentProps>(({ bold, textColor }) => ({
  color: textColor,
  fontWeight: bold ? Fonts.fontWeight.bold : undefined,
}))
